import { Skeleton } from '@/components/ui/skeleton';
import React from 'react';

const DefaultSkeletonSymbolLoader = () => {
    return (
        <div className={'min-h-[35vh] w-full'}>
            <Skeleton className='mb-3 h-[30px] w-[200px] rounded-full bg-primary/20 dark:bg-white/20' />
            <Skeleton className='my-1 h-[30px] w-full rounded-full bg-primary/20 dark:bg-white/20' />
            <Skeleton className='my-1 h-[30px] w-full rounded-full bg-primary/20 dark:bg-white/20' />
            <Skeleton className='my-1 h-[30px] w-full rounded-full bg-primary/20 dark:bg-white/20' />
            <Skeleton className='my-1 h-[30px] w-full rounded-full bg-primary/20 dark:bg-white/20' />
            <Skeleton className='my-1 h-[30px] w-full rounded-full bg-primary/20 dark:bg-white/20' />
            <Skeleton className='my-1 h-[30px] w-full rounded-full bg-primary/20 dark:bg-white/20' />
            <Skeleton className='my-1 h-[30px] w-full rounded-full bg-primary/20 dark:bg-white/20' />
            <Skeleton className='my-1 h-[30px] w-full rounded-full bg-primary/20 dark:bg-white/20' />
            <Skeleton className='my-1 h-[30px] w-full rounded-full bg-primary/20 dark:bg-white/20' />
        </div>
    );
};

export default DefaultSkeletonSymbolLoader;
